<template>
  <div class="wdx login login-container text-center">
    <div class="row login-block">
      <div class="col">
        <h2 class="text-primary">Registration</h2>
      </div>
    </div>

    <RegistrationInformationComponent
      v-if="showRegInfo"
      :departments="departments"
      :branches="branches"
    />

    <div class="row mt-3" v-if="notification">
      <div class="col">
        <div class="notification p-3 text-center">
          {{ notification }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WdxBaseComponentMixin from '../../common/mixins/wdxBaseComponent';
import RegistrationInformationComponent from './registrationInformation';

export default {
  mixins: [WdxBaseComponentMixin],
  components: {
    RegistrationInformationComponent
  },
  data() {
    return {
      notification: null,
      showRegInfo: false,
      regToken: null,
      departments: [],
      branches: []
    };
  },
  computed: {},
  mounted: function () {
    this.getInitialInfo();
  },
  methods: {
    getInitialInfo() {
      this.showLoading();
      this.$userService
        .getRegistrationInitialInfo()
        .then((response) => {
          this.hideLoading();
          const resp = response.data;
          if (resp && resp.UserWasFound) {
            this.showRegInfo = true;
            this.departments = resp.CompanyDepartments;
            this.branches = resp.CompanyStations;
          } else {
            this.notification = 'Your registration information was not found.';
          }
        })
        .catch((error) => {
          this.hideLoading();

          if (error && error.response && error.response.status == 400) {
            this.$router.push({ name: 'emailInput' });
            return;
          }

          this.handleHttpError(error, true);
        });
    }
  }
};
</script>

<style></style>
